package com.tovtalk.domain.entity

/**
 * Verification request info
 */
data class VerificationRequestInfo(
    val status: String?,
    val code: String?,
    val phoneToCall: String?,
    val canStart: Boolean = true,
    val retryDaysRemaining: Int? = null
)
